"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledRadiosPropType = exports.StyledRadios = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = require("../../../../UIElements/Tooltip/Tooltip");
var _StyledRadioInput = require("./StyledRadioInput");
var _ValidationMessages = require("../../ValidationMessages");
var _validationPropType = require("../../../../../propTypes/validationPropType");
var _TabbableInputGroup = require("../../../../../hooks/TabbableInputGroup");
var _ScreenReaderMode = require("../../../../UIElements/ScreenReaderMode/ScreenReaderMode");
require("../RadioInputs.scss");
var _hooks = require("../../../../../hooks");
const _excluded = ["fieldFormContext", "userContext", "customCssClass", "onChange", "value", "groupName", "groupLabel", "groupLabelTooltip", "hideGroupLabel", "required", "radioInputs", "customCssClassPrefix", "name", "validation"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledRadios = _ref => {
  let {
      fieldFormContext,
      userContext,
      customCssClass,
      onChange,
      value,
      groupName,
      groupLabel,
      groupLabelTooltip,
      hideGroupLabel = false,
      required,
      radioInputs,
      customCssClassPrefix,
      name,
      validation
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [isTouched, setIsTouched] = (0, _react.useState)(false);
  const radioInputsGroup = (0, _react.useRef)(null);
  const screenReaderMode = (0, _ScreenReaderMode.GetScreenReaderMode)({
    userContext
  });
  (0, _TabbableInputGroup.useTabbableInputGroup)({
    groupWrappingElementRef: radioInputsGroup,
    userContext
  });
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    onBlur: () => setIsTouched(true),
    className: "formField radiosGroup ".concat(customCssClass || '', " ").concat(isTouched ? 'touched' : '')
  }, !screenReaderMode && /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Screen reader users are advised that this radio group supports custom keyboard navigation between radio options via tabbing."), groupLabel && /*#__PURE__*/_react.default.createElement("legend", {
    className: "".concat(hideGroupLabel ? 'sr-only' : 'labelText radiosGroupHeading', " ").concat(required ? 'mandatory' : '', " ").concat(groupLabelTooltip ? 'labelDecoration' : '')
  }, groupLabel, groupLabelTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    customTrackingData: {
      tooltipForLabel: {
        groupLabel
      }
    }
  }, groupLabelTooltip)), /*#__PURE__*/_react.default.createElement("div", {
    ref: radioInputsGroup,
    className: "radioInputs radioInputs_".concat(radioInputs.length)
  }, radioInputs.map(radioInput => /*#__PURE__*/_react.default.createElement(_StyledRadioInput.StyledRadioInput, _extends({
    isOnlyOption: radioInputs.length === 1,
    fieldFormContext: fieldFormContext,
    onChange: onChange,
    value: value,
    required: validation && validation.required,
    customCssClassPrefix: customCssClassPrefix,
    radioInput: radioInput,
    key: radioInput.value,
    groupName: groupName,
    name: name,
    validation: validation
  }, rest)))), /*#__PURE__*/_react.default.createElement(_ValidationMessages.ValidationMessages, {
    formContext: fieldFormContext,
    name: name,
    validation: validation
  }));
};
exports.StyledRadios = StyledRadios;
const StyledRadiosPropType = exports.StyledRadiosPropType = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: _propTypes.default.any,
  // eslint-disable-next-line react/forbid-prop-types
  userContext: _propTypes.default.any,
  // eslint-disable-next-line react/forbid-prop-types
  rest: _propTypes.default.any,
  customCssClass: _propTypes.default.string,
  customCssClassPrefix: _propTypes.default.string,
  onChange: _propTypes.default.func,
  groupName: _propTypes.default.string.isRequired,
  groupLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.element]),
  groupLabelTooltip: _propTypes.default.string,
  hideGroupLabel: _propTypes.default.bool,
  required: _propTypes.default.bool,
  radioInputs: _propTypes.default.arrayOf(_StyledRadioInput.StyledRadioPropType),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  name: _propTypes.default.string,
  validation: _propTypes.default.shape(_validationPropType.ValidationPropType)
};
StyledRadios.propTypes = StyledRadiosPropType;
var _default = exports.default = StyledRadios;